import { Mui } from '@osu/react-ui';
import { useState } from 'react';
import MenuDialogBase from "./MenuDialogBase";
import { useGetScholarsProgramsQuery, useAssignApplicationToProgramMutation } from "../../../services/graphql/api";
import { getScholarsApplDetailParams } from "../ScholarsApplicant";

// has "Assign" — mirrors DialogAssign (Assign Reviewer) but assigns the APPLICATION to a Scholars
// scholars program. The chosen program's manager owns the resulting queue entry, which surfaces the applicant
// on that program manager's dashboard In Progress table (via the manuallyAssignedProgram field). Admin-only
// (gated by the menu item + the resolver's SCHOLARS-ADMIN group). Term is derived server-side.
export default function DialogAssignToProgram({ menuItemAndClose }) {
    const params = getScholarsApplDetailParams();
    const { data: programs = [] } = useGetScholarsProgramsQuery();

    const [apiCall, result] = useAssignApplicationToProgramMutation();
    const [subProgramId, setSubProgramId] = useState("");

    const variables = { applicantEmployeeId: params?.applicantEmployeeId, subProgramId };
    const isDisabled = !subProgramId;
    const buttons = [{ label: "Assign", apiCall, variables, isDisabled }];
    const message = "Assign this applicant to a program. The program's manager will see the applicant in their dashboard's In Progress table.";

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
            extraContent={(
                <>
                    <Mui.Typography tabIndex={0} sx={{ marginBottom: 0 }}>{message}</Mui.Typography>

                    <br/>

                    <Mui.FormControl fullWidth required>
                        <Mui.InputLabel id="dialog-assign-program-choose">Choose Scholars Program</Mui.InputLabel>
                        <Mui.Select
                            disabled={result?.isLoading || result.isSuccess}
                            sx={{ width: "100%" }}
                            label="Choose Scholars Program"
                            labelId="dialog-assign-program-choose"
                            value={subProgramId}
                            onChange={event => setSubProgramId(event.target.value)}>
                                {programs.map((program) => (
                                    <Mui.MenuItem key={program.subProgramId} value={program.subProgramId}>
                                        {program.label ?? program.subProgramId}
                                    </Mui.MenuItem>
                                ))}
                        </Mui.Select>
                    </Mui.FormControl>
                </>
            )}
        />
    );
}
